import { render, staticRenderFns } from "./BasicInformationSection.vue?vue&type=template&id=9815b458&scoped=true&"
import script from "./BasicInformationSection.vue?vue&type=script&lang=js&"
export * from "./BasicInformationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9815b458",
  null
  
)

export default component.exports